import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-part-cmsp-ohi-dw",
  templateUrl: "./part-cmsp-ohi-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartCMspOhiDWComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.PartCMspOhiDW;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, "Customer_Name", "Project ID", HideFilters.CUSTOMER_NAME2];
}
